export const formatTime = (value?: string): string => {
  if (!value) {
    return '';
  }

  switch (value.length) {
    case 1:
      return `000${value}`;
    case 2:
      return `00${value}`;
    case 3:
      return `0${value}`;
    default:
      return value;
  }
};
